export const MEDALLIA_FERGHOME_FORM_ID = 52183;
export const MEDALLIA_EMPLOYEE_FORM_ID = 58177;
export const MEDALLIA_PDP_SPECS_FORM_ID = 60864;
export const MEDALLIA_SCRIPT_URL = 'https://nebula-cdn.kampyle.com/us/wu/1193605/onsite/embed.js';
export const MEDALLIA_PDP_SPECS_EMBEDDED_FORM_ID = 'pdp-specs-emb-form';
